<template>
  <home-base-rail label="autores" variant="authors">
    <home-author-card v-for="author in items" :key="author.id" :author="author" />
  </home-base-rail>
</template>

<script>
import HomeBaseRail from "./HomeBaseRail.vue";
import HomeAuthorCard from "@/components/home/cards/HomeAuthorCard.vue";

export default {
  name: "HomeAuthorRail",
  components: { HomeBaseRail, HomeAuthorCard },
  props: {
    items: { type: Array, default: () => [] },
  },
};
</script>
